const STORAGE_KEY = 'onboarding_registration_progress';

const getStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { completedSections: [] };
  } catch {
    return { completedSections: [] };
  }
};

const setStorage = (data) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {}
};

export const saveCompletedSection = (sectionId) => {
  const data = getStorage();
  if (!data.completedSections.includes(sectionId)) {
    data.completedSections.push(sectionId);
    setStorage(data);
  }
};

export const getCompletedSections = () => getStorage().completedSections;

export const clearRegistrationProgress = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
};
